import { Injectable } from "@angular/core";
import { ApiBaseService } from "../service/api-base.service";
import { Observable } from "rxjs";
import { environment as env } from '../../../environments/environment';
import { AdapterService } from "../service/adapter.service";
@Injectable({ providedIn: "root" })
export class AuthenticationService {

  constructor(
    private readonly apiBaseSevice: ApiBaseService,
    private readonly adaptersService: AdapterService ) {
  }


  login(model): any {


    return this.apiBaseSevice.post("user/login", model);


  }

  upsert(model): any{
    return this.apiBaseSevice.post("user/upsert", model);
  }

  getToken() {
    return this.adaptersService.getLocalStorageValue(env.storageKeys.fichas);
  }

  getExpiry() {
    return this.adaptersService.getLocalStorageValue("expiry");
  }

  getUser() {

    return this.adaptersService.getLocalStorageValue(env.storageKeys.user);


  }

  clearCredentials() {
    this.adaptersService.setLocalStorageValue(env.storageKeys.user, null);
    this.adaptersService.setLocalStorageValue(env.storageKeys.fichas, null);

  }




}
